import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { Documents } from '../@types/SendPolicyDocumentsByEmail'

type Store = {
  policyDocuments: Documents[]
  setPolicyDocuments: (value: Documents[]) => void
  addPolicyDocuments: (value: Documents) => void
  deletePolicyDocuments: (keyRef: string) => void
}

export const usePolicyDocumentsSelectedStore = create<Store>()(
  devtools(
    (set) => ({
      policyDocuments: [],
      setPolicyDocuments: (policyDocuments) => set({ policyDocuments }),
      addPolicyDocuments: (document) =>
        set((state) => {
          const newData = [...state.policyDocuments, document]
          return { policyDocuments: newData }
        }),
      deletePolicyDocuments: (keyRef) =>
        set((state) => {
          const newData = state?.policyDocuments?.filter(
            (file) => file.keyRef !== keyRef,
          )

          return { policyDocuments: newData }
        }),
    }),
    { name: 'PolicyDocumentsSelectedStore' },
  ),
)
